"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthModals = void 0;
const useStore_1 = require("root/src/client/logic/helpers/useStore");
const displayModal_1 = __importDefault(require("root/src/client/logic/modal/actions/displayModal"));
const moduleIds_1 = require("root/src/shared/descriptions/modules/moduleIds");
const react_1 = require("react");
const useAuthModals = () => {
    const dispatch = (0, useStore_1.useAppDispatch)();
    const displaySignInModal = (0, react_1.useCallback)(() => {
        dispatch((0, displayModal_1.default)(moduleIds_1.SIGN_IN_MODAL_MODULE_ID));
    }, [dispatch]);
    return {
        displaySignInModal,
    };
};
exports.useAuthModals = useAuthModals;
